var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeedbackOther(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13582_67892)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.5 15.8496C13.2279 15.8496 16.25 12.8275 16.25 9.09961C16.25 5.37169 13.2279 2.34961 9.5 2.34961C5.77208 2.34961 2.75 5.37169 2.75 9.09961C2.75 12.8275 5.77208 15.8496 9.5 15.8496Z",
    stroke: "#42296E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 9.94336C9.96599 9.94336 10.3438 9.5656 10.3438 9.09961C10.3438 8.63362 9.96599 8.25586 9.5 8.25586C9.03401 8.25586 8.65625 8.63362 8.65625 9.09961C8.65625 9.5656 9.03401 9.94336 9.5 9.94336Z",
    fill: "#42296E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.875 9.94336C13.341 9.94336 13.7188 9.5656 13.7188 9.09961C13.7188 8.63362 13.341 8.25586 12.875 8.25586C12.409 8.25586 12.0312 8.63362 12.0312 9.09961C12.0312 9.5656 12.409 9.94336 12.875 9.94336Z",
    fill: "#42296E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.125 9.94336C6.59099 9.94336 6.96875 9.5656 6.96875 9.09961C6.96875 8.63362 6.59099 8.25586 6.125 8.25586C5.65901 8.25586 5.28125 8.63362 5.28125 9.09961C5.28125 9.5656 5.65901 9.94336 6.125 9.94336Z",
    fill: "#42296E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13582_67892"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0.5 0.0996094)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedbackOther);
export default __webpack_public_path__ + "static/media/feedback-other.b489687a39f6fb4637fbf9303f66d95b.svg";
export { ForwardRef as ReactComponent };